import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'z-1 h-fit w-full gap-2 bg-white py-1',
    container: 'flex-center container flex flex-col gap-6',
    carousel:
      'mx-auto w-fit max-w-full select-none [--slide-size:auto] [--slide-spacing:8px]',
    viewport:
      'max-xl:-mx-4 max-xl:w-[calc(100%+32px)] max-xl:px-4 max-sm:-mx-3 max-sm:w-[calc(100%+24px)] max-sm:px-3',
    pickUpCareMobile: 'max-sm:w-full sm:hidden',
    pickUpCare: 'max-sm:hidden',
    naosIconWrapper: 'flex-center hidden sm:flex',
    controls: 'pointer-events-none absolute inset-0 max-md:hidden',
    controlsContainer: 'container h-full',
    controlsInner: 'relative h-full max-xl:-mx-4',
    controlsButton: 'top-1'
  },
  variants: {
    withoutGap: {
      true: {
        container: 'max-sm:gap-0'
      }
    }
  }
});
